import React from 'react';
import styled from 'styled-components';
import { GoogleLogin, GoogleOAuthProvider, CredentialResponse } from '@react-oauth/google';
import theme from '../styles/theme';

const GoogleButtonContainer = styled.div`
  width: 100%;

  > div {
    width: 100% !important;
  }

  button {
    width: 100% !important;
    height: 44px !important;
    border: 1.5px solid ${theme.colors.cardBorder} !important;
    background: ${theme.colors.card} !important;
    border-radius: ${theme.radius.md} !important;
    padding: 8px !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    cursor: pointer !important;
    transition: all ${theme.transitions.fast} !important;
    box-shadow: ${theme.shadows.xs} !important;

    &:hover {
      background: ${theme.colors.bg} !important;
      border-color: rgba(255, 107, 107, 0.25) !important;
    }

    &:active {
      background: ${theme.colors.bg} !important;
    }

    div {
      width: 18px !important;
      height: 18px !important;
      padding: 0 !important;
      margin: 0 !important;
      margin-left: 6px !important;
    }

    span {
      font-family: "Roboto", "Google Sans", arial, sans-serif !important;
      font-size: 14px !important;
      color: #3c4043 !important;
      font-weight: 500 !important;
      letter-spacing: 0.25px !important;
      flex: 1 !important;
      text-align: center !important;
      padding-right: 24px !important;
    }
  }
`;

interface GoogleAuthButtonProps {
    onSuccess: (credentialResponse: CredentialResponse) => void;
    text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin';
}

const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({ onSuccess, text = 'signin_with' }) => {
    return (
        <GoogleOAuthProvider clientId="753369775438-0t7k7qp4bp0i6n0jjftg5p1rrq4aae99.apps.googleusercontent.com">
            <GoogleButtonContainer>
                <GoogleLogin
                    onSuccess={onSuccess}
                    onError={() => console.log('Login Failed')}
                    useOneTap
                    type="standard"
                    theme="outline"
                    size="large"
                    text={text}
                    shape="rectangular"
                    width="100%"
                    locale="en"
                />
            </GoogleButtonContainer>
        </GoogleOAuthProvider>
    );
};

export default GoogleAuthButton; 